import React, { Component } from "react";

import Title from './Title';
import SelectedCriterion from './SelectedCriterion';
import TradingPreferenceSelectors from './TradingPreferenceSelectors';

import './AS-result.css';

class Result extends Component {
  constructor (props) {
    super();
    this.state = {};
  }

  _handleLogoClick () {
    this.props.history.push('/')
  }

  _prepareSelectedCriteriaJSX = (step, defaultJSX) => {
    let selectedCriteria = this.props.criteriaData[step];

    // Step 3
    if (step === 3) {
      return [
        <TradingPreferenceSelectors
          data={selectedCriteria}
          clicked={this.props.clicked}
          valueOnUpdate={this.props.valueOnUpdate}
        />
      ];
    }

    // Step 1 & 2
    if (selectedCriteria.size < 1) {
      return defaultJSX;
    }
    let rsp = [];
    selectedCriteria.forEach(criterion =>
      rsp.push(
        <SelectedCriterion
          updateAttribute={this.props.updateAttribute}
          valueOnUpdate={this.props.valueOnUpdate}
          sortType={this.props.sortType}
          clicked={this.props.clicked}
          remove={this.props.remove}
          key={criterion.label}
          step={step}
          criterion={criterion}>
        </SelectedCriterion>
      )
    );

    return rsp;
  }

  render () {
    let defaultCriteriaJSX =
      <p className="result-init font-color-dark">Based on which metric would you like to screen your stocks</p>;
    let criteriaJSX = this._prepareSelectedCriteriaJSX(1, defaultCriteriaJSX);

    let defaultSortJSX =
      <p className="result-init font-color-dark">Based on which metric would you like to sort your stocks</p>;
    let sortJSX = this._prepareSelectedCriteriaJSX(2, defaultSortJSX);

    let defaultOtherJSX =
      <p className="result-init font-color-dark">Please select your stock trading preferences</p>;
    let otherJSX = this._prepareSelectedCriteriaJSX(3, defaultOtherJSX);

    return (
      <div className="AS-result">
        <div className="result-header">
          <div className="logo" onClick={() => this._handleLogoClick()} />
        </div>
        <div className="steps">
          <div className={this.props.currentStep === 1 ? "step border-bottom selected" : "step border-bottom"}>
            <Title
              onClick={() => this.props.stepSelected(1)}
              index={1} title="Select Filter Metrics"></Title>
            {criteriaJSX}
          </div>
          <div className={this.props.currentStep === 2 ? "step border-bottom selected" : "step border-bottom"}>
            <Title
              onClick={() => this.props.stepSelected(2)}
              index={2} title="Select Sort Metrics"></Title>
            {sortJSX}
          </div>
          <div className={this.props.currentStep === 3 ? "step border-bottom selected" : "step border-bottom"}>
            <Title
              onClick={() => this.props.stepSelected(3)}
              index={3} title="Select Other Preferences"></Title>
            {otherJSX}
          </div>
        </div>
        <div className="AS-submit">
          <button onClick={() => this.props.onSubmit()}>Submit</button>
        </div>
      </div>
    )
  }
}

export default Result;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/sidebar/Result.js